var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"download"),React.createElement("path",{"d":"M0.941 27.922h28.235v3.137h-28.235v-3.137zM16.627 18.78l9.523-9.525 2.218 2.218-13.31 13.311-13.31-13.31 2.218-2.22 9.523 9.522v-17.522h3.137v17.525z","key":1})]);
}

Download.defaultProps = {"version":"1.1","width":"30","height":"32","viewBox":"0 0 30 32"};

module.exports = Download;

Download.default = Download;
